module.exports = __webpack_public_path__ + "fonts/NotoSansGeorgian-Light.d3ab421f.eot";